import { Component, AfterViewInit, OnInit, Input, ViewChildren, Output, EventEmitter, HostListener } from "@angular/core";
import { Appointment, Area, AreasTags, Option, StyleChoice, Tag, TutorialVideo } from "../../engine/models/models";
import { Utilities } from "../../helpers/utilities";
import { AreasService } from "../../services/areas.service";
import { Globals } from "../../services/globals";
import { NgxWatermarkOptions } from "ngx-watermark";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { StyleSelectionsComponent } from "../components/style-selections/style-selections.component";
import { environment } from "../../../environments/environment";
import { VideoComponent } from "../video/video.component";
import { AreaType, VideoType } from "../../enum";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from "rxjs";
import { GroupedOptionsModel } from "../../models/GroupedOptionsModel";
import { GroupedOptionsModalComponent } from "../grouped-options-modal/grouped-options-modal.component";
import { VisualizeComponent } from "../visualize/visualize.component";
import { debug } from "console";
@Component({
  templateUrl: "selections.component.html",
  styleUrls: ["selections.component.css"]
})

export class SelectionsComponent implements OnInit, AfterViewInit {
  @Input() collectionImages: string;
  @Input() collectionId: number = 0;
  visualize: boolean;
  selectedArea: Area;
  nextArea: Area;
  selectedOption: Option;
  utilities: Utilities = new Utilities();
  isListView = false;
  isOptionSelected = false;
  filteredAreas: Area[] = [];
  appointment: Appointment;
  subDescription: string;
  isStyleSelected = false;
  isSideBar = false;
  displayedTags: Tag[] = [];
  tag: Tag[] = [];
  areasTags: AreasTags[] = [];
  selectedTag: Tag;
  notSelectedImageUrl = "/assets/images/needsSelection.png";
  optionUpdateSubscription: any;
  includeOptions: any;
  watermarkOptions: NgxWatermarkOptions = {
    text: "TRUE VALUE",
    width: 120,
    height: 120,
    fontFamily: "Kanit",
    color: "#fda33d",
    alpha: 0.3,
    degree: 45,
    fontSize: "15px",
  };

  emptyWatermarkOptions: NgxWatermarkOptions = {
    text: "",
  };

  previousArea: Area;
  placeholder = false;
  viewOptionSubscription: Subscription;
  @ViewChildren("list_container") list_container;
  showVideo = true;
  constructor(public globals: Globals,
    private areasService: AreasService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar) {
   
    this.viewOptionSubscription = this.globals.viewOption.subscribe(option => {
      this.ngOnInit();
      this.viewOption(option);
    });
   
    this.globals.selectedOtherArea = 'Inspiration Builds Here';
    this.globals.hideHeader = false;
    this.globals.validateSession();
    this.globals.initAutoSave();

    if (localStorage.getItem("appointment")) {
      let appointment = JSON.parse(localStorage.getItem('appointment'));
      this.showVideo = appointment.isSelectionVideoWatched ? false : true;
      if (this.globals.isImpersonating) {
        this.showVideo = false;
      }
    }
  }
  //transform(url) {
  //  return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  //}
  optionsText: string = this.watermarkOptions.text;
  optionsFont: string = this.watermarkOptions.fontFamily;
  optionsAlpha: number = this.watermarkOptions.alpha;
  optionsWidth: number = this.watermarkOptions.width;
  optionsHeight: number = this.watermarkOptions.height;
  optionsDegree: number = this.watermarkOptions.degree;
  optionsFontSize: string = this.watermarkOptions.fontSize;


  @HostListener('unloaded')
  ngOnDestroy() {
    this.viewOptionSubscription.unsubscribe();
  }

  optionsTextChange() {
    this.updateOptions({ text: this.optionsText });
  }

  optionsFontChange() {
    this.updateOptions({ fontFamily: this.optionsFont });
  }

  optionsAlphaChange() {
    this.updateOptions({ alpha: this.optionsAlpha });
  }

  optionsWidthChange() {
    this.updateOptions({ width: this.optionsWidth });
  }

  optionsHeightChange() {
    this.updateOptions({ height: this.optionsHeight });
  }

  optionsDegreeChange() {
    this.updateOptions({ degree: this.optionsDegree });
  }

  optionsFontSizeChange() {
    this.updateOptions({ fontSize: this.optionsFontSize });
  }

  private updateOptions(_obj: any) {
    this.watermarkOptions = Object.assign({}, this.watermarkOptions, _obj);
  }

  public get areaType(): typeof AreaType {
    return AreaType;
  }

  ngOnInit() {
    this.globals.validateSession();
    if (this.globals.previousSelectedArea) {
      this.selectedArea = this.globals.areas.find(x => x.id === this.globals.previousSelectedArea);
      if (!this.selectedArea) {
        this.selectedArea = this.globals.areas.find(x => x.subAreas && x.subAreas.some(s => s.id === this.globals.previousSelectedArea));
      }
      this.globals.selectedArea = this.selectedArea;
    }
    //this.visualize = this.selectedArea != undefined ?( this.selectedArea.id == 3 ? environment.visualize.Kitchen : this.selectedArea.id == 5 ? environment.visualize.Bathrooms : this.selectedArea.id == 9 ? environment.visualize.Exterior : false):false;
    setTimeout(() => {
      const element: HTMLElement = document.getElementById("nav") as HTMLElement;
      if (element !== null) {
        element.hidden = true;
      }
      this.initalizeAreas();
    }, 800);
  }

  ngAfterViewInit() {
    if (this.globals.previousSelectedOption) {
      this.viewOption(this.globals.previousSelectedOption);
    }
  }

  initalizeAreas() {
    if (this.globals.engine === undefined) {
      requestAnimationFrame(() => this.initalizeAreas());
    }
    else {
      if (!this.globals.areas || !this.selectedArea) {
        this.areasService.getAreas().subscribe(areas => {
          this.globals.areas = areas;
          this.filterAreas(false);
        });
      }
      else {
        this.filterAreas(false);
      }
    }

  }

  filterAreas(navigate = true) {
    if (!this.globals.engine) {
      requestAnimationFrame(() => this.filterAreas());
    }

    else {
      this.optionUpdateSubscription = this.globals.engine.onSelectionUpdated().subscribe(option => {
        this.checkAreasStatus();
        this.checkTagsStatus();
      });
      for (const area of this.globals.areas) {
        if (area.areaType == AreaType.Area) {
          if (this.globals.engine.optionsByArea(area.id, this.globals.areas, null).length > 0) {
            // Selected Options
            if (!this.filteredAreas.includes(area)) {
              this.filteredAreas.push(area);
            }
          } else if (this.globals.engine.optionalOptionsByArea(area.id, this.globals.areas, null).length > 0) {
            // Optional Options
            if (!this.filteredAreas.includes(area)) {
              this.filteredAreas.push(area);
            }
          }
        }
        else {
          if (!this.filteredAreas.includes(area)) {
            this.filteredAreas.push(area);
          }
        }
      }
      this.filterTags();
      //this.tagsByAreas();
      this.checkAreasStatus();

      const areaNativeElements = this.list_container.toArray();


      if (!this.globals.displayRooms && !this.globals.previousSelectedArea) {
        this.navigateToArea(this.filteredAreas[0]);
        // Navigate to first element
        if (navigate && areaNativeElements && !this.globals.displayRooms) {
          const element = areaNativeElements[0]?.nativeElement;
          if (element) {
            this.indicatorX = (element.offsetLeft + element.offsetWidth - 4) + "px";
          }
        }
      }

      //if (this.globals.previousSelectedArea > 0) {
      //  this.navigateToArea(this.selectedArea);
      //}
      if (!this.globals.displayRooms && this.globals.selectedArea) {
        this.navigateToAreaById(this.globals.selectedArea.id, undefined);
      }
      if (this.globals.displayRooms) {
        this.selectedArea = this.globals.areas.find(x => x.areaType == AreaType.Inspiration);
        this.globals.selectedArea = this.globals.areas.find(x => x.areaType == AreaType.Inspiration);
        this.globals.showNotificationPanel();
      }
    }
  }

  checkForSelected(option: Option): boolean {
    option.isStyleSelected = true;

    // Optional Option Selection (with a requirement to select but no default)
    if (option.isRequired && !option.selectedOption) {
      if (option.childOptions && option.childOptions.length === 1) {
        option.childOptions[0].isSelected = true;
        option.selectedOption = option.childOptions[0];
        option.styleSelections = option.childOptions[0].styleSelections
      } else if (option.hasIncludedFeature && option.childOptions && option.includedFeatureOptionId) {
        let selectedOption = option.childOptions.find(x => x.optionId == option.includedFeatureOptionId)
        if (selectedOption) {
          selectedOption.isIncluded = selectedOption.isSelected = true;
          option.selectedOption = selectedOption;
          option.styleSelections = selectedOption.styleSelections
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    //Check if included option have any default selection or not.
    if (option.isRequired && option.selectedOption.optionId === option.optionId && option.childOptions) {
      const selectedOption = option.childOptions.find(x => x.isSelected);
      if (!selectedOption) {
        option.isStyleSelected = false;
        return;
      }
    }
    //Check if included option have any style selection or not.
    this.includeOptions = option.childOptions?.filter(x => x.isIncludedFeature);
    if (option.selectedOption) {
      if (option.selectedOption.styleSelections) {
        for (const style of option.selectedOption.styleSelections) {
          for (const choice of style.styleChoices) {
            if (choice.isSelected) {
              option.isStyleSelected = true;
              break;
            }
            else {
              option.isStyleSelected = false;
            }
          }
        }
      }
    }
    this.subDescription = "";
    this.isOptionSelected = false;

    if (option.isSelected && !option.childOptions) {
      option.selectedOption = option;
      this.isOptionSelected = true;
      //if (option.selectedOption.price === 0) {
      //  option.selectedOption = option;
      //}
      this.subDescription = this.selectedOptionAndStyleDescription(option);
      return true;
    }

    if (option.childOptions && option.childOptions.length > 1) {
      const isSelected = option.childOptions.find(x => x.isSelected);
      if (isSelected) {
        option.selectedOption = option.childOptions.find(x => x.isSelected || x.isAdded);
        this.subDescription = this.selectedOptionAndStyleDescription(option);
        this.isOptionSelected = true;
        return true;
      }
    }
    else {
      if (option.isAdded) {
        this.isOptionSelected = true;
        return true;
      }
    }
  }

  checkAreasStatus() {
    this.filteredAreas.forEach(area => {
      area.status = this.globals.engine.status[0].status;
      if (this.selectedArea?.id !== area.id) {
        area.status = this.globals.engine.status[1].status;
      }
      const includedOptions = this.globals.engine.optionsByArea(area.id, this.globals.areas, null);
      if (includedOptions.length > 0) {
        includedOptions.forEach(option => {
          this.checkForSelected(option);
        });
      }
      //else {
      //  if (this.selectedArea?.id !== area.id) {
      //    area.status = this.globals.engine.status[1].status;
      //  }
      //}
      const optionalOptions = this.globals.engine.optionalOptionsByArea(area.id, this.globals.areas, null);
      if (optionalOptions.length > 0) {
        optionalOptions.forEach(option => {
          this.checkForSelected(option);
        });
      }

      //const selectedOptions = includedOptions.filter(x => x.selectedOption?.price > 0).length + optionalOptions.filter(x => x.selectedOption?.price > 0).length;

      // if (selectedOptions > 0) {
      area.status = this.globals.engine.status[0].status;
      const notCompletedIncluded = includedOptions.filter(x => !x.isStyleSelected);
      const notCompletedOptional = optionalOptions.filter(x => !x.isStyleSelected && x.selectedOption?.styleSelections);
      if (notCompletedIncluded.length + notCompletedOptional.length === 0) {
        area.status = this.globals.engine.status[1].status;
      }
      //}
      if (this.selectedArea?.id === area.id) {
        area.status = this.globals.engine.status[0].status;
      }
    });
    this.checkTagsStatus();
    //this.visualize = this.selectedArea != undefined ? (this.selectedArea.id == 3 ? environment.visualize.Kitchen : this.selectedArea.id == 5 ? environment.visualize.Bathrooms : this.selectedArea.id == 9 ? environment.visualize.Exterior : false) : false;
  }

  checkTagsStatus() {
    this.displayedTags.forEach(tag => {
      tag.status = this.globals.engine.status[0].status;
      if (this.selectedTag.name !== tag.name) {
        tag.status = this.globals.engine.status[1].status;
      }
      const includedOptions = this.globals.engine.optionsByArea(this.selectedArea.id, this.globals.areas, tag.name);
      if (includedOptions.length > 0) {
        includedOptions.forEach(option => {
          this.checkForSelected(option);
        });
      }
      //else {
      //  if (this.selectedTag.name !== tag.name) {
      //    tag.status =this.globals.engine.status[1].status;
      //  }
      //}
      const optionalOptions = this.globals.engine.optionalOptionsByArea(this.selectedArea.id, this.globals.areas, tag.name);
      if (optionalOptions.length > 0) {
        optionalOptions.forEach(option => {
          this.checkForSelected(option);
        });
      }
      // const selectedOptions = includedOptions.filter(x => x.selectedOption?.price > 0).length + optionalOptions.filter(x => x.selectedOption?.price > 0).length;

      // if (selectedOptions > 0) {
      tag.status = this.globals.engine.status[0].status;
      const notCompletedIncluded = includedOptions.filter(x => !x.isStyleSelected);
      const notCompletedOptional = optionalOptions.filter(x => !x.isStyleSelected && x.selectedOption?.styleSelections);

      if (notCompletedIncluded.length + notCompletedOptional.length === 0) {
        tag.status = this.globals.engine.status[1].status;
      }
      // }
      if (this.selectedTag.name === tag.name) {
        tag.status = this.globals.engine.status[0].status;
      }
    });
  }

  orderByChildOptions(option: Option): Option {
    let includeOptions = option.childOptions.filter(x => x.isIncludedFeature || x.isIncluded || !x.price || x.price == 0);
    let optionalOptions = option.childOptions.filter(x => !includeOptions.includes(x));
    option.childOptions = includeOptions.concat(optionalOptions);
    return option;
  }

  viewOption(option: Option) {
    if (option.childOptions && option.childOptions.length > 1) {
      option = this.orderByChildOptions(option);
    }
    this.selectedOption = option;
    this.globals.selectedOption = option;
    if (this.globals.previousSelectedOption !== option) {
      this.globals.previousSelectedOption = option;
    }
  }

  sortByPriceAscending(options: Option[]) {
    if (options) {
      options = options.sort((a, b) => a.price - b.price);
    }
    return options;
  }

  showPrice(option: Option) {
    if (option.childOptions && option.childOptions.length === 1) {
      if (option.childOptions[0].isAdded) {
        return true;
      }
    }
    if (option.isAdded && !option.childOptions) {
      return true;
    }
    return false;
  }

  getOptionPrice(option: Option) {
    if (option.childOptions && option.childOptions.length === 1) {
      return option.childOptions[0].price;
    }
    return option.price;
  }

  showAddRemove(option: Option) {
    if (option.childOptions && option.childOptions.length === 1) {
      return true;
    }
    if (!option.childOptions) {
      return true;
    }
    return false;
  }

  areasByDisplayOrder(): Area[] {
    return this.filteredAreas.sort((a, b) => a.displayOrder - b.displayOrder);
  }

  getCounts(tag: string, area: Area) {
    if (this.globals.engine?.optionDefinitions) {
      // const area = this.selectedArea;
      const subAreas = area.subAreas;
      if (this.globals.engine?.optionDefinitions) {
        const displayedOptions = this.globals.engine.optionDefinitions.filter(q => subAreas.map((s) => { return s.id }).includes(q.areaId));
        const optionalOptions = displayedOptions.filter(option => !option.isRequired && !option.isSelected && option.isVisible);
        const includedOptions = displayedOptions.filter(q => q.isSelected && q.selectedOption && q.isVisible);
        if (tag === "Other Options") {
          const optionalOptionsWithoutTag = optionalOptions.filter(option => !option.hasOwnProperty("tag"));
          const includedOptionsWithoutTag = includedOptions.filter(option => !option.hasOwnProperty("tag"));
          const count = optionalOptionsWithoutTag.length + includedOptionsWithoutTag.length;
          return count;
        }
        const optionalOptionsWithTag = this.globals.engine.getTags(optionalOptions, tag);
        const includedOptionsWithTag = this.globals.engine.getTags(includedOptions, tag);
        const count = optionalOptionsWithTag.length + includedOptionsWithTag.length;
        return count;
      }
    }
  }

  filterTags() {
    if (!this.globals.engine) {
      requestAnimationFrame(() => this.filterTags());
    }
    else {
      if (this.globals?.engine?.optionDefinitions) {
        this.filteredAreas.forEach(area => {
          this.tag = [];
          const subAreas = area.subAreas;

          const displayedOptions = this.globals.engine.optionDefinitions.filter(q => subAreas.map((s) => { return s.id }).includes(q.areaId));
          if (this.globals.engine.optionTags) {
            const displayedOptionIds = displayedOptions.filter(q => q.isVisible || q.isSelected)
              .map(({ optionId }) => optionId.toString());

            const tags = [];
            for (const displayedOptionId of displayedOptionIds) {
              const availableTags = this.globals.engine.optionTags.filter(x => x.options.split(",").includes(displayedOptionId));
              if (availableTags.length > 0) {
                const count = this.getCounts(availableTags[0].displayName, area);
                if (count > 0) {
                  tags.push(availableTags);
                }
              }
            }
            if (tags.length > 0) {
              tags.sort((a, b) => +a[0].displayOrder - +b[0].displayOrder);
              const distinctTagName = tags.map(item => item[0].displayName ? item[0].displayName : item[0].tagName)
                .filter((value, index, self) => self.indexOf(value) === index);
              distinctTagName.forEach(tag => {
                this.tag.push({ name: tag, isVisited: false, status: this.globals.engine.status[0].status });
              });
            }

            const optionalOptions = displayedOptions.filter(option => !option.isRequired && !option.isSelected && option.isVisible);
            const includedOptions = displayedOptions.filter(q => q.isSelected && q.isVisible);

            const optionalOptionsWithoutTag = optionalOptions.filter(option => !option.hasOwnProperty("tag"));
            const includedOptionsWithoutTag = includedOptions.filter(option => !option.hasOwnProperty("tag"));
            const count = optionalOptionsWithoutTag.length + includedOptionsWithoutTag.length;
            if (count > 0) {
              this.tag.push({ name: "Other Options", isVisited: false, status: this.globals.engine.status[0].status });
            }
          }

          this.selectedTag = this.displayedTags[0];
          if (this.selectedTag) {
            this.globals.selectedTag = JSON.parse(JSON.stringify(this.selectedTag));
          }
          if (this.tag[0]) {
            this.tag[0].isVisited = true;
            this.tag[0].status = this.globals.engine.status[0].status;
          }
          this.areasTags.push({ areaId: area.id, tag: this.tag });
        })
      }
    }
  }

  tagsByAreas() {
    if (!this.globals.engine || !this.selectedArea) {
      requestAnimationFrame(() => this.tagsByAreas());
    }
    else {
      if (this.areasTags.length > 0) {
        if (this.areasTags.some(x => x.areaId === this.selectedArea.id)) {
          this.displayedTags = this.areasTags.find(x => x.areaId === this.selectedArea.id).tag;
          if (this.displayedTags.length > 0) {
            if ((this.globals.selectedTag && this.displayedTags.some(x => x.name === this.globals.selectedTag.name))
              || (this.globals.selectedOption && this.displayedTags.some(x => x.name === this.globals.selectedOption.tag))) {
              this.selectedTag = this.displayedTags.find(x => (this.globals.selectedOption && x.name === this.globals.selectedOption.tag));
              if (!this.selectedTag) {
                this.selectedTag = this.displayedTags.find(x => (this.globals.selectedTag && x.name === this.globals.selectedTag.name));
              }
              this.selectedTag.isVisited = true;
              this.selectedTag.status = this.globals.selectedTag.status;
              this.globals.selectedTag = JSON.parse(JSON.stringify(this.selectedTag));
            } else {
              this.selectedTag = this.displayedTags[0];
              this.globals.selectedTag = JSON.parse(JSON.stringify(this.selectedTag));
              this.displayedTags[0].isVisited = true;
              this.displayedTags[0].status = this.globals.engine.status[0].status;
            }
          }
        }
      }
      else {
        this.filterTags();
        this.tagsByAreas();
      }
    }
  }

  tagChanged(tag: Tag) {
    tag.isVisited = true;
    tag.status = this.globals.engine.status[0].status;
    this.selectedTag = tag;
    this.globals.selectedTag = JSON.parse(JSON.stringify(this.selectedTag));
    this.globals.selectedOption = this.selectedOption = null;
    this.checkAreasStatus();
    this.globals.saveDataIfApplicable();
  }

  getAreaDisplayIndex(id: number) {
    return this.globals.areas.findIndex(x => x.id === id);
  }

  getNextArea(id: number) {
    const i = this.getAreaDisplayIndex(id);
    if (i === this.globals.areas.length) {
      return null;
    }
    return this.globals.areas[this.getAreaDisplayIndex(id) + 1];
  }

  getPreviousArea(id: number) {
    const i = this.getAreaDisplayIndex(id);
    if (!i) {
      return null;
    }
    return this.globals.areas[this.getAreaDisplayIndex(id) - 1];
  }

  indicatorX = "165px";
  transitionWidth = "0";
  hideSubMenu = true;

  openVideoDialog(video: TutorialVideo) {
    this.snackBar.dismiss();
    this.globals.selectedVideo = video;

    //set height for video player
    localStorage.setItem('windowHeight', (window.innerHeight - 60).toString())
    const videoDialog = this.dialog.open(VideoComponent, { minWidth: '98%', disableClose: true });
    videoDialog.afterClosed().subscribe(result => { this.globals.showNotificationPanel() });
  }

  navigateToAreaById(areaId: number, element: PointerEvent) {
    let showNotification = true;

    if (areaId) {
      const video = this.globals.appointment.tutorialVideos.find(x => x.videoType == VideoType.Selection);
      if (video && !video.isWatched) {
        if (!this.globals.isImpersonating) {
          video.disableClose = true;
          video.showNotifictaion = true;
          showNotification = false;
          this.openVideoDialog(video)
        }
      }
    }
   
    this.globals.displayRooms = false;
    this.globals.displayCompleted = false;
    this.placeholder = false;
    this.hideSubMenu = false;
    this.globals.previousSelectedArea = areaId;

    if (element) {
      this.updateStatusSlider(element.currentTarget as HTMLUListElement);
    }

    this.globals.hasBackgroundHeaderImage = false;
    this.globals.backgroundHeaderImage = null;

    if (areaId) {
      const area = this.globals.areas[this.getAreaDisplayIndex(areaId)];
      area.isVisited = true;

      this.globals.hasBackgroundHeaderImage = true;

      // Temporary - needs to be configurable
      switch (area.name) {
        case "Kitchen":
          this.globals.backgroundHeaderImage = "/assets/images/potspans.png";
          break;
        default:
          this.globals.hasBackgroundHeaderImage = false;
          this.globals.backgroundHeaderImage = null;
      }

      if (area.name === "Value Packages") {
        this.hideSubMenu = true;
      }
      this.navigateToArea(area);
    }
    else {
      this.clearAreaSelection();
      this.globals.selectedOtherArea = 'True Value';
      // Use a placeholder for now.
      this.selectedArea = this.globals.areas.find(x => x.areaType == AreaType.TrueValue);
      this.globals.selectedArea = this.globals.areas.find(x => x.areaType == AreaType.TrueValue);
      this.placeholder = true;
      this.hideSubMenu = true;
    }
    if (showNotification && !this.globals.previousSelectedOption) {
      this.globals.showNotificationPanel();
    }
    this.globals.saveDataIfApplicable();
  }

  updateStatusSlider(li: HTMLUListElement) {
    if (li) {
      this.indicatorX = li.offsetLeft + li.offsetWidth - 4 + "px";
    }
  }

  wipeRight() {
    this.transitionWidth = "calc(100% - 72px)";
  }

  wipeLeft() {
    this.transitionWidth = "0";
    this.list_container.toArray().forEach(element => {
      const li = element.nativeElement as HTMLUListElement;
      if (li.className.includes("current")) {
        this.updateStatusSlider(li);
        return;
      }
    });
  }

  navigateToArea(area: Area) {
    if (this.globals.engine === undefined) {
      requestAnimationFrame(() => this.navigateToArea(area));
    }
    else {
      // Google Analytics
      this.globals.navigateVirtualPage(area.name);

      this.globals.selectedArea = this.selectedArea = area;
      this.tagsByAreas();
      this.checkAreasStatus();
      setTimeout(() => this.wipeLeft(), 500);
    }
  }

  navigateToInspiration(areaId: number, element: PointerEvent) {
    this.clearAreaSelection();
    this.selectedArea = this.globals.areas.find(x => x.id == areaId);
    this.globals.selectedArea = this.globals.areas.find(x => x.id == areaId);
    this.globals.showNotificationPanel();
    this.globals.hasBackgroundHeaderImage = false;
    this.globals.backgroundHeaderImage = null;
    this.globals.displayRooms = true;
    this.hideSubMenu = true;
    this.globals.roomGroupId = null;
    if (element) {
      this.updateStatusSlider(element.currentTarget as HTMLUListElement);
    }
    this.globals.selectedOtherArea = 'Inspiration Builds Here';
  }

  navigateToComplete(element: PointerEvent) {
    this.clearAreaSelection();
    this.globals.showNotificationPanel();
    this.globals.hasBackgroundHeaderImage = false;
    this.globals.backgroundHeaderImage = null;
    this.globals.displayRooms = false;
    this.globals.displayCompleted = true;
    this.hideSubMenu = true;
    this.globals.roomGroupId = null;
    if (element) {
      this.updateStatusSlider(element.currentTarget as HTMLUListElement);
    }
    this.globals.selectedOtherArea = 'Completed';
  }

  clearAreaSelection() {
    //this.globals.hasBackgroundHeaderImage = false;
    //this.globals.backgroundHeaderImage = null;
    this.globals.showRoomGroupings = true;
    this.globals.selectedOption = this.selectedOption = null;
    this.globals.selectedArea = this.selectedArea = null;
    this.selectedTag = null;
    this.globals.selectedTag = null;
    this.displayedTags = [];
  }

  clearSelectedOption(showDesignerTip: boolean) {
    this.globals.previousSelectedOption = this.globals.selectedOption = this.selectedOption = null;
    if (showDesignerTip) {
      this.globals.showNotificationPanel();
    }
  }

  // Used to change the option when selected in the cart
  selectOptionAndArea(option: Option) {
    if (option) {
      const area = this.globals.getClientAreaBySubAreaId(option.areaId);
      if (this.globals.viewOptionFromCart) {
        this.viewOptionFromCart(option, area);
        this.globals.viewOptionFromCart = false;
        this.hideSubMenu = false;
      }
      else {
        this.navigateToArea(area);
      }

      if (option.childOptions && option.childOptions.length > 1) {
        option = this.orderByChildOptions(option);
      }
      this.selectedOption = option;
    }
  }

  viewOptionFromCart(option: Option, area: Area) {
    this.clearAreaSelection();
    this.selectedArea = area;
    this.tagOption(option, area);
    this.checkAreasStatus();
    setTimeout(() => this.wipeLeft(), 1000);
  }

  tagOption(option: Option, area: Area) {
    if (this.areasTags.length > 0) {
      this.displayedTags = this.areasTags.find(x => x.areaId === area.id).tag;
      this.selectedTag = this.displayedTags.find(x => x.name == option.tag);
      this.globals.selectedTag = JSON.parse(JSON.stringify(this.selectedTag));
      this.displayedTags[0].isVisited = true;
      this.displayedTags[0].status = this.globals.engine.status[0].status;
    }
  }

  selectedOptionAndStyleDescription(option: Option) {
    let subDescription: string;
    this.isStyleSelected = false;
    if (option.selectedOption.isSelected || option.selectedOption.isAdded) {
      if (option.selectedOption.styleSelections && option.selectedOption.styleSelections.length > 0) {
        for (const style of option.selectedOption.styleSelections) {
          for (const choice of style.styleChoices) {
            if (choice.isSelected) {
              this.isStyleSelected = true;
              if (!subDescription) {
                subDescription = (option.selectedOption.displayName ? option.selectedOption.displayName : option.selectedOption.description) + " : " + choice.description;
              }
              else {
                subDescription += ", " + choice.description;
              }
            }
          }
        }
        if (!subDescription && option.childOptions) {
          subDescription = (option.selectedOption.displayName ? option.selectedOption.displayName : option.selectedOption.description);
        }
        return subDescription;
      }
      else {
        if (option.childOptions) {
          return subDescription = (option.selectedOption && option.selectedOption.displayName ? option.selectedOption.displayName : (option.selectedOption?.description));
        }
        return subDescription;
      }
    }
  }

  openStyleDialog(option: Option, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!option.styleSelections) {
      option.styleSelections = option.selectedOption.styleSelections;
    }
    const styleDialog = this.dialog.open(StyleSelectionsComponent, {
      id: "style-selections",
      minWidth: "71%",
      width: "71%",
      data: { option }
    });
    styleDialog.afterClosed().subscribe(result => {
      this.checkAreasStatus();
    });
  }

  setStyle(option: Option, choice: StyleChoice, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.globals.engine.selectOption(option.selectedOption.parentOptionId ? option.selectedOption.parentOptionId : option.optionId, option.selectedOption.optionId, option.selectedOption.styleSelections[0].optionId, choice.optionId, choice.isLiked);
  }

  setOption(parentOptionId, childOptionId, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.globals.engine.selectOption(parentOptionId, childOptionId, null, null,false);
  }

  scrollToTop() {
    window.scroll(0, 0);
  }

  checkStyleSelection(option: Option) {
    if (option?.selectedOption?.styleSelections[0]?.styleChoices?.length > 3) {
      return true;
    }
    else {
      return false;
    }
  }

  formatProfileImageUrl(url: string) {
    // If the URL is null, simply return it.
    if (!url) { return url; }

    // Only add the host URL if it doesn't already include it
    if (url.includes("http") || url.includes("assets")) {
      return url;
    }
    return environment.userProfileImage + this.encode(url);
  }

  encode(imageUrl: string): string {
    imageUrl = imageUrl.replace(/\(/g, "%28");
    imageUrl = imageUrl.replace(/\)/g, "%29");
    return imageUrl;
  }

  get getCollectionImage(): string {
    let collectionTheme = JSON.parse(localStorage.getItem("CollectionTheme"));
    return collectionTheme.find(x => x.collectionId == this.globals.appointment.collectionId).imageUrl; 
  }

  getOptionList(areaId: number, areas: Area[], tag: string) {
    const allOption = this.globals.engine.optionsByArea(areaId, areas, tag).concat(this.globals.engine.optionalOptionsByArea(areaId, areas, tag));
    const options: Option[] = allOption.filter(x => x.isPackage).concat(allOption.filter(x => !x.isPackage));
    return options;
  }
  openVisualDialog() {
    const visualDialog = this.dialog.open(VisualizeComponent, { minWidth: '98%', disableClose: false });
    visualDialog.afterClosed().subscribe(result => { return; });


    //this.showTutorial();
  }
}
